<template>
    <v-container fluid class="secondary">
      <v-card elevation="11" class="primary">
          <v-row class="justify-center">
          <template v-if="!propsdb.length">
            <v-col cols="11">
            <v-row class="justify-center align-center ma-3 pa-3 "><h2 class="textTitle--text">{{ $t('propmanager.noPropsMessage') }}</h2></v-row>
            
              <v-row class="justify-center">
                <v-btn large class="ma-5 pa-5 success font-weight-black black--text" @click="addPropForm">{{ $t('propmanager.createPropButton') }}</v-btn>
                </v-row>
                </v-col>
          </template>

          <template v-else>
            <v-col cols="5">
            <v-card class="ma-3 pa-3 secondary"> 
            <v-card-title class="headline justify-center font-weight-black textTitle--text">{{ $t('propmanager.propDetail') }}</v-card-title>
            <div class="ma-2"><h3 class="textMenu--text">{{ $t('propmanager.propName') }}</h3></div><v-chip light label class="quinty"><h3 class="primary--text font-weight-black">{{propactive.name}}</h3></v-chip>
            <div class="ma-2"><h3 class="textMenu--text">{{ $t('propmanager.propType') }}</h3></div><v-chip light label class="quinty"><h3 class="primary--text font-weight-black">{{propactive.typeform}}</h3></v-chip>
            <div class="ma-2" :v-if="propactive.typeform==$t('propmanager.selectOption3')"><h3 class="textMenu--text">{{ $t('propmanager.propSelectValues') }}</h3></div><v-chip light label class="quinty"><h3 class="primary--text font-weight-black">{{propactive.selectoptions}}</h3></v-chip>
            <v-card-actions>
              <v-row class="justify-center">
                <v-btn small class="ma-2 error font-weight-black black--text" @click="removeProp">{{ $t('delete') }}</v-btn>
                <v-btn small class="ma-2 info font-weight-black black--text" @click="modifPropScreen=true;addpropScreen=false">{{ $t('modify') }}</v-btn>
              </v-row>
            </v-card-actions>
            </v-card>
            </v-col>

          
          
          
          <v-col cols="6">
              <v-card class="ma-3 pa-3 secondary" solo elevation="11">
                  <v-card-title class="headline justify-center font-weight-black textTitle--text">{{ $t('propmanager.currentProps') }}</v-card-title>

            <v-chip-group
                column
                active-class="primary--text justify-center"
                v-model="propactive"
                return-object
                mandatory
                
              >
                <v-chip
                  v-for="prop in propsdb"
                  :key="prop.id"  
                  :value="prop"  
                  color="quinty"
                  class="ma-2 pa-4"  
                  light         
                >
                  <h3 class="primary--text font-weight-black">{{ prop.name }}</h3>
                </v-chip>
              </v-chip-group>
              <v-divider></v-divider>
              <v-row class="justify-center">
                <v-btn small class="ma-2 success font-weight-black black--text" @click="addPropForm">{{ $t('propmanager.addPropButton') }}</v-btn>
                </v-row>
              </v-card>

          </v-col>

          </template>
          </v-row>

<v-card v-if="addpropScreen" elevation="11" class="ma-5 pa-3 secondary">
    <v-card-title class="headline justify-center font-weight-black textTitle--text">{{ $t('propmanager.addPropButton') }}</v-card-title>

      <v-row class="justify-center">
        <v-col cols="5">
            <v-text-field
                  v-model="nameprop"
                  :label="$t('propmanager.propName')"
                  required
                  solo
                  class="ma-2 font-weight-black"
                  background-color="quinty"
                  outlined
                  light
                ></v-text-field>
                <v-textarea
                  solo
                  v-model="descprop"
                  :label="$t('propmanager.propDesc')"
                  class="ma-2 font-weight-black"
                  light
                  background-color="quinty"
                  outlined
                ></v-textarea>
                <v-select background-color="quinty" light v-model="typeformprop" :items="selectoptions" :label="$t('propmanager.propType')" class="ma-2 font-weight-black" solo >
                </v-select>
         </v-col>
         <v-col cols="5">
                <v-card v-if="typeformprop==$t('propmanager.selectOption3')" class="ma-1 pa-1 secondary" flat>
                    <v-row class="justify-center">
                    <v-text-field background-color="quinty" light :label="$t('propmanager.propSelectValues')" class="ma-1 font-weight-black" outlined solo v-model="optionselectprop"></v-text-field>
                    <v-btn class="ma-3 pa-2 font-weight-black black--text" small color="success" @click="addPropSelectOption">{{ $t('add') }}</v-btn>
                    </v-row>
                    
                    <v-list light dense class="quinty"> 
                      <v-row class="justify-center primary">
                    <h2 class="justify-center font-weight-black textMenu--text">{{ $t('propmanager.propSelectValues') }}</h2>
                    </v-row>
                    <v-list-item-group
                      color="primary"
                      
                    >
                      <v-list-item
                        v-for="(item, i) in listoptionselectprop"
                        :key="i"
                      >
                        
                        <v-list-item-content>
                          <v-row class="justify-center align-center">
                          <h2 class=" ml-5 pa-1 font-weight-black black--text">{{item}}</h2>
                          <v-btn class="ml-5 pa-2" x-small color="error font-weight-black black--text" @click="removePropSelectOption(item)">{{ $t('delete') }}</v-btn>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>

                </v-card>
            </v-col>
            </v-row>
                <v-row class="justify-center">
                  <v-btn @click="addPropToDb" x-large class="ma-5 success font-weight-black black--text">{{ $t('confirm') }}</v-btn>
                </v-row>
                <v-dialog :retain-focus='false' width="550px" v-model="confirmProdCreation">
              <successMessage @close="confirmProdCreation=false" :title="'Confirmacion'" :message="'La propriedad '+nameprop+' esta creada.'" :key="errorKey"/>
            </v-dialog>
      </v-card>

      <v-card v-if="modifPropScreen" elevation="11" class="ma-5 pa-3 secondary">
    <v-card-title class="headline justify-center font-weight-black textTitle--text">{{ $t('modify') }}</v-card-title>

      <v-row class="justify-center">
        <v-col cols="5">
            <v-text-field
                  v-model="propactive.name"
                  :label="$t('propmanager.propName')"
                  required
                  solo
                  class="ma-2 font-weight-black"
                  background-color="quinty"
                  outlined
                  light
                ></v-text-field>
                <v-textarea
                  solo
                  v-model="propactive.desc"
                  :label="$t('propmanager.propDesc')"
                  class="ma-2 font-weight-black"
                  light
                  background-color="quinty"
                  outlined
                ></v-textarea>
                <v-select background-color="quinty" light v-model="propactive.typeform" :items="selectoptions" :label="$t('propmanager.propType')" class="ma-2 font-weight-black" solo >
                </v-select>
         </v-col>
         <v-col cols="5">
                <v-card v-if="propactive.typeform==$t('propmanager.selectOption3')" class="ma-1 pa-1 secondary" flat>
                    <v-row class="justify-center">
                    <v-text-field background-color="quinty" light :label="$t('propmanager.propSelectValues')" class="ma-1 font-weight-black" outlined solo v-model="optionselectprop"></v-text-field>
                    <v-btn class="ma-3 pa-2 font-weight-black black--text" small color="success" @click="addPropSelectOptionModif">{{ $t('add') }}</v-btn>
                    </v-row>
                    
                    <v-list light dense class="quinty"> 
                      <v-row class="justify-center primary">
                    <h2 class="justify-center font-weight-black textMenu--text">{{ $t('propmanager.propSelectValues') }}</h2>
                    </v-row>
                    <v-list-item-group
                      color="primary"
                      
                    >
                      <v-list-item
                        v-for="(item, i) in propactive.selectoptions"
                        :key="i"
                      >
                        
                        <v-list-item-content>
                          <v-row class="justify-center align-center">
                          <h2 class=" ml-5 pa-1 font-weight-black black--text">{{item}}</h2>
                          <v-btn class="ml-5 pa-2" x-small color="error font-weight-black black--text" @click="removePropSelectOptionModif(item)">{{ $t('delete') }}</v-btn>
                          </v-row>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>

                </v-card>
            </v-col>
            </v-row>
                <v-row class="justify-center">
                  <v-btn @click="confirmModifProp" x-large class="ma-5 success font-weight-black black--text">{{ $t('modifConfirm') }}</v-btn>
                </v-row>
      </v-card>
    </v-card>
  
</v-container>
</template>

<script>
import successMessage from '@/components/successMessage'
import {mapActions} from 'vuex'
import {mapGetters} from 'vuex'
  export default {
      props:[],
      components:{successMessage},
    data () {
      return {
        selectedprops:[],
            optionselectprop:'',
            listoptionselectprop:[],
            selectedoptionselectprop:'',
            propactive:{id:'',name:'',desc:'',typeform:'',selectoptions:[]},
            removingprop:false,
            nameprop:'',
            typeformprop:'',
            descprop:'',
            qtyprops:0,
            modifPropScreen:false,
            addpropScreen:false,
            confirmProdCreation:false,
            errorKey:0,
      }
    },
    mounted(){

    },
    computed:{
      selectoptions(){
        var typeformoptions=[this.$t('propmanager.selectOption1'),this.$t('propmanager.selectOption2'),this.$t('propmanager.selectOption3')]
        return typeformoptions
      },
      ...mapGetters({
        propsdb:'propsDb',
      })
    },
    methods: {
      addPropForm(){
        this.addpropScreen=true;
        this.modifPropScreen=false;
      },
      confirmModifProp(){
        this.modifProp(this.propactive)
        this.modifPropScreen=false;
      },
        removePropSelectOptionModif(option){
        
        this.temparray=[];
          if(option!=null){
            var size = this.propactive.selectoptions.length; 
            for(var i=0;i<size;i++){
              if(this.propactive.selectoptions[i]!=option){
                    this.temparray.push(this.propactive.selectoptions[i])
              }                  
            }
            this.propactive.selectoptions=this.temparray;
            
          }
      },
      removePropSelectOption(option){
        
        this.temparray=[];
          if(option!=null){
            var size = this.listoptionselectprop.length; 
            for(var i=0;i<size;i++){
              if(this.listoptionselectprop[i]!=option){
                    this.temparray.push(this.listoptionselectprop[i])
              }                  
            }
            this.listoptionselectprop=this.temparray;
            
          }
      },
      addPropSelectOption(){
        const option = this.optionselectprop;
        var has=0;
        if(option!=null){
          const size = this.listoptionselectprop.length;
          if(size!=null){
            for(var i=0;i<size;i++){
              if(option==this.listoptionselectprop[i]){has=1}
            }
          }
          if(has==0){this.listoptionselectprop.push(option)}
          
        }
        
      },
      addPropSelectOptionModif(){
        const option = this.optionselectprop;
        var has=0;
        if(option!=null){
          const size = this.propactive.selectoptions.length;
          if(size!=null){
            for(var i=0;i<size;i++){
              if(option==this.propactive.selectoptions[i]){has=1}
            }
          }
          if(has==0){this.propactive.selectoptions.push(option)}
          
        }
        
      },
        addPropToDb(){
            var name = this.nameprop;
            var desc = this.descprop;
            var typeform = this.typeformprop;
            var id = 'prop1';
            var propdb = this.propsdb;
            var pos = 0        
        // ajoute l'item en verifiant l'id. si l'id existe, continue d'essayer jusqu'a trouver un id valide, 
        // permet de remplir les vides laisser par les suppressions precedentes
        
            if(propdb.length>0){
               
            var size = propdb.length+1
            pos=1

            for(var i=0;i<size-1;i++){
              if(propdb[i].id!=id){continue}else{
                pos+=1
                id='prop'+pos
                id=0
              }
            }
            } 

        // inscrit l'item dans la bdd et recharge
                var selectoptions=[];
                if(typeform==this.$t('propmanager.selectOption3')){selectoptions=this.listoptionselectprop}

                var prop={
                  'id':id,'name':name,'desc':desc,'typeform':typeform,'value':null,'selectoptions':selectoptions
                }
                console.log(prop)
                this.addProp(prop)
                this.addpropScreen=false
            this.confirmProdCreation=true
        },
        removeProp(){
            
            this.deleteProp(this.propactive)
        },
         ...mapActions([
        'deleteProp',
        'addProp',
        'modifProp'
      ]),

    },
  }
</script>